/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports BalancerApiBusinessObject
 */
import { Balancer, P2PDefaultSettings, Events } from '../Utils/Constants';
import XhrRequest from '../Utils/XhrRequest';
export default class BalancerApiBusinessObject {
    constructor(loader) {
        this.p2pProbability = 0;
        this._loader = loader;
    }
    loadBalancerData(accountCode, resource, isLive, applicationCode, originCode) {
        const res = this.getRouteAndFilename(resource);
        const isDev = false; // 'undefined' !== typeof location && Balancer.devDomains.indexOf(location.host) >= 0;
        const host = isDev ? Balancer.devHost : Balancer.host;
        const req = new XhrRequest(`${host}/${accountCode}${applicationCode ? `/${applicationCode}` : ''}`, Balancer.service);
        req.on(Events.Get.Success, (e) => {
            try {
                this.options = JSON.parse(e.data.response);
                this._loader.storage.setSettings(this.options);
                this.p2pProbability = this.options.p2p.p2pPercentage || P2PDefaultSettings.probability;
                this._loader.CDNLoader.setSettings(this.options, res.route);
                this._loader.CDNLoader.startMonitoring();
                if (this._loader.P2PLoader)
                    this._loader.P2PLoader.setSettings(this.options);
            }
            catch (e) {
                console.error('Error parsing Balancer API response: ', e);
            }
        });
        req.send({
            resource: res.route + res.fileName,
            live: isLive,
            extended: true,
            npawPluginInfo: true,
            originCode: originCode
        });
    }
    getRouteAndFilename(stringUrl) {
        const url = new URL(stringUrl);
        const route = url.origin + url.pathname;
        const limit = route.lastIndexOf('/') + 1;
        return {
            route: route.slice(0, limit),
            fileName: route.slice(limit)
        };
    }
}
